/**
 * The page is imported from **its own module**, not from the `@pages` barrel: the barrel re-exports
 * every page, so one import would pull all of them into the chunk the entry preloads.
 */
import { createFileRoute } from '@tanstack/react-router';

import { TemplatesPage } from '@pages/templates/page.js';
import { TemplateModel } from '@units/template';
import { IamService } from '@units/iam';

/**
 * `/templates` — wiring only (`rules/frontend-fsd.mdc` правило 10).
 *
 * `whenDenied: 'forbidden'` — раздел стоит в навигации у каждого, кто держит право, поэтому его
 * существование не секрет внутри организации, и отказ может назвать, чего не хватает (тот же выбор,
 * что у `/drafts` и `/documents`). Схема отбора провалидирована здесь, чтобы правленный руками
 * адрес не доехал до компонента.
 */
export const Route = createFileRoute('/_authenticated/templates/')({
  beforeLoad: IamService.IamGuards.requirePermission({
    permission: 'template:read',
    whenDenied: 'forbidden',
  }),
  validateSearch: TemplateModel.templateRegistrySearchSchema,
  component: TemplatesPage,
  staticData: { crumbKey: 'nav.templates' },
});
